// React
import React, { useRef } from 'react'
import PropTypes from 'prop-types'

// Components
import BCartPicker from 'ui/blocks/Picker/types/cart'
import { DurationsPicker } from './Picker'
import Icon from 'ui/components/Icon'
import Span from 'ui/elements/Span'

// Hooks
import { usePicker } from 'ui/components/Picker/hooks'
import { useTranslation } from 'shared/utils/useTranslation'
import useWindowSize from 'shared/utils/useWindowSize'

export const DurationsDesktop = (props) => {
  const portalRef = useRef(null)

  const picker = usePicker()

  const { width } = useWindowSize()

  const { t } = useTranslation('user')

  // 866px is the breakpoint when the modal is starting to shrink
  const numberOfMonths = width > 866 && props.inline ? 2 : 1

  return (
    <DurationsPicker
      {...props}
      portalRef={portalRef}
      numberOfMonths={numberOfMonths}
      usePortal={{
        date: props.inline,
        time: false
      }}
    >
      <BCartPicker.Portal ref={portalRef}>
        <BCartPicker.PeriodReset onClick={picker.reset} data-tid="Clear dates">
          <Icon icon="times" />
          <Span>{t('user.store.clear_dates')}</Span>
        </BCartPicker.PeriodReset>
      </BCartPicker.Portal>
    </DurationsPicker>
  )
}

DurationsDesktop.propTypes = {
  inline: PropTypes.bool
}
